/** @format */

import { ProductSelectionState } from '@pdp/data-access/interfaces';
import { createReducer, on } from '@ngrx/store';
import {
	appInitializerKillswitchesSet,
	windowFlagsEventKillswitchesSet
} from './killswitches.actions';

export const killswitchesReducer = createReducer(
	{} as ProductSelectionState['killswitches'],
	on(
		appInitializerKillswitchesSet,
		windowFlagsEventKillswitchesSet,
		(state, { killswitches }) => ({
			...killswitches
		})
	)
);
